
    import { Vue, Component } from 'vue-property-decorator'
    @Component({
        name: 'read'
    })
    export default class read extends Vue {
        questionnaire= {}
        questionnaireId = ''
        replayId = ''
        fullscreenLoading = false
        visible = false
        dialogVisible = false
        form={
            replayForm:[]
        }
        replyMessageFrom = {
            questionId: '', //问题id
            replayId: '', //回答id
            replyMessage: '', //回复回答问题
            value: '' // 问题回答值
        }
        rules={
            optionId: [{required: true, trigger: 'blur', message: '请选择选项'}],
            value: [{required: true, trigger: 'blur', message: '请填写内容或打分'}],
        }
        // mounted(){
        //     this.questionnaireId = this.$route.query.questionnaireId
        //     this.replayId = this.$route.query.replayId
        //     this.getArticle();
        // }
        init(val: any) {
            console.log("问卷回答详情页面参数：",val)
            this.visible = true
            this.fullscreenLoading = true;
            this.questionnaireId = val.questionnaireId
            this.replayId = val.id
            this.getArticle()
        }
        getArticle() {
            this.$request({
                url: `/bjba/questionnaireReplay/allInfo`,
                params:{questionnaireId:this.questionnaireId,replayId:this.replayId},
                method: 'get'
            }).then(response => {
                this.fullscreenLoading = false;
                if (response.data.data.questionEntities && response.data.data.questionEntities.length>0) {
                    this.form.replayForm = response.data.data.questionEntities.map((e: { id: any;type:any })=>{
                        let data ;
                        if (e.type == 2)  {
                            if (e.checkOption){
                                data = {type:e.type,questionId:e.id,optionId:'',optionIds:e.checkOption.split(","),value:''}
                            }
                        } else data = {type:e.type,questionId:e.id,optionId:e.checkOption,optionIds:[],value:e.value,replyMessage:e.replyMessage,replyMessageTime:e.replyMessageTime}
                        return data
                    })
                }
                this.questionnaire = response.data.data
                console.log("问卷回答信息：",this.form)
                console.log("问卷信息：",this.questionnaire)
            }).catch(error => {
                this.fullscreenLoading = false;
                console.log(error)
            });
        }
        submitQuestionnaire() {
            this.$refs.questionnaireForm.validate((valid) => {
                if (valid) {
                    this.fullscreenLoading = true;
                    let data = {data: {questionnaireId:this.questionnaire.id},questionnaireReplayInfos:this.form.replayForm}
                    this.$request({
                        url: `/bjba/questionnaireReplay/save`,
                        method: 'post',
                        data: data
                    }).then(({data}) => {
                        this.fullscreenLoading = false;
                        if (data && data.code === 200) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500
                            })
                            this.visible = false
                            this.$emit('refreshDataList')
                        } else if(data && data.code === 500) {
                            this.$message({
                                message: data.message,
                                type: 'error',
                                duration: 1500
                            })
                        }
                    })
                }
            })
        }
        handleClose() {
            this.visible = false
            this.$emit('refreshDataList')
        }
        reply(data: any) {
            console.log("回复数据为：",data)
            // this.replyMessageFrom = {
            //     questionId: '', //问题id
            //     replayId: '', //回答id
            //     replyMessage: '', //回复回答问题
            //     value: '' // 问题回答值
            // }
            this.dialogVisible = true
            this.replyMessageFrom.replayId = this.replayId
            this.replyMessageFrom.questionId = data.questionId
            this.replyMessageFrom.value = data.value
            this.replyMessageFrom.replyMessage = data.replyMessage
            console.log("问题回复表单数据为：",this.replyMessageFrom)
        }
        submitReplyMessage() {
            this.$request({
                url: `/bjba/questionnaireReplay/updateReplyMessage`,
                method: 'post',
                data: this.replyMessageFrom
            }).then(({data}) => {
                this.dialogVisible = false
                if (data && data.code === 200) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                    })
                    this.getArticle()
                    this.updateCustomerReadState()
                } else if(data && data.code === 500) {
                    this.$message({
                        message: data.message,
                        type: 'error',
                        duration: 1500
                    })
                }
            }).catch(error => {
                this.dialogVisible = false;
                console.log(error)
                this.$message({
                    message: '操作失败',
                    type: 'error',
                    duration: 1500
                })
            });
        }
        updateCustomerReadState() {
            this.$request({
                url: `/bjba/questionnaireReplay/updateCustomerReadState/${this.replayId}`,
                method: 'get',
                params: {
                    customerReadState: '01'
                }
            }).then(response => {
                console.log("修改问卷回复查阅状态值返回信息：",response)
            }).catch(error => {
                console.log(error)
            });
        }
    }
